/* eslint camelcase: 0 */
import { Log } from '@/infrastructure/network/Monitaro/schema/models'
import { ILogProps, EmptyLogPropsFactory } from '@/entities/Log'

export const toLogProps = (props: Log | null | undefined): ILogProps => {
  if (!props) {
    return EmptyLogPropsFactory()
  }

  const { id, created_at } = props

  return EmptyLogPropsFactory({
    id,
    createdAt: created_at
  })
}
